module.exports = __webpack_public_path__ + "static/mens-health-selected-22eb94809eb52ea4492e05180027e188.svg";